import React from 'react'

import Header from '@/layouts/Header'
import Main from '@/layouts/Main'

const RootLayout: React.FC = () => {
  return (
    <section className="grid h-screen grid-rows-[4rem_auto]">
      <Header />
      <Main />
    </section>
  )
}

export default RootLayout
